import type { UploadJob } from "../hooks/useUploads";
import { Icon } from "./icons";

function formatEta(seconds: number): string {
  const s = Math.max(1, Math.round(seconds));
  if (s < 90) return `${s} s`;
  return `${Math.round(s / 60)} min`;
}

interface Props {
  job: UploadJob;
  onCancel: (id: number) => void;
}

export function UploadRow({ job, onCancel }: Props) {
  // Prozent ans Ende: die rechtsbündig verankerte, kurze Zahl bleibt so
  // optisch ruhig, während die Restzeit links davon variieren darf
  const status =
    job.progress === null
      ? "lädt hoch …"
      : job.progress >= 1
        ? "wird verarbeitet …"
        : `${job.eta !== null ? `noch ca. ${formatEta(job.eta)} · ` : ""}${Math.round(job.progress * 100)} %`;

  return (
    <div className="upload-row card">
      <div className="upload-info">
        <span className="upload-label">
          <Icon name="upload" /> {job.label}
        </span>
        <span className="muted">{status}</span>
        {(job.progress === null || job.progress < 1) && (
          <button
            className="icon-btn danger"
            onClick={() => onCancel(job.id)}
            aria-label="Upload abbrechen"
            title="Upload abbrechen"
          >
            <Icon name="x-lg" size={14} />
          </button>
        )}
      </div>
      <div className="upload-bar">
        {job.progress === null && job.stalled ? (
          // Eigener key: beim Moduswechsel wird das Element ersetzt,
          // damit die width-Transition nicht sichtbar „springt“
          <div key="anim" className="upload-bar-fill indeterminate" />
        ) : (
          <div
            key="percent"
            className="upload-bar-fill"
            style={{ width: `${Math.min(100, (job.progress ?? 0) * 100)}%` }}
          />
        )}
      </div>
    </div>
  );
}
